import { render, staticRenderFns } from "./HallDetails.vue?vue&type=template&id=271f3bce&scoped=true"
import script from "./HallDetails.vue?vue&type=script&lang=js"
export * from "./HallDetails.vue?vue&type=script&lang=js"
import style0 from "./HallDetails.vue?vue&type=style&index=0&id=271f3bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f3bce",
  null
  
)

export default component.exports